import React from "react";

const BirthDayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.22613 6.2H19.7817M4.22613 6.2V16.8667H19.7817V6.2M4.22613 6.2V10.4667L5.05979 10.0665C5.89494 9.66564 6.89118 9.82512 7.55946 10.4667C8.21125 11.0924 9.20686 11.1901 9.96787 10.7031L10.3372 10.4667C11.3532 9.81644 12.6546 9.81644 13.6706 10.4667L14.0399 10.7031C14.801 11.1901 15.7966 11.0924 16.4483 10.4667C17.1166 9.82512 18.1129 9.66564 18.948 10.0665L19.7817 10.4667V6.2M7.55946 6.2C8.17311 6.2 8.67057 5.72244 8.67057 5.13333C8.67057 4.7406 8.3002 4.02949 7.55946 3C6.81872 4.02949 6.44835 4.7406 6.44835 5.13333C6.44835 5.72244 6.94581 6.2 7.55946 6.2ZM12.0039 6.2C12.6176 6.2 13.115 5.72244 13.115 5.13333C13.115 4.7406 12.7446 4.02949 12.0039 3C11.2632 4.02949 10.8928 4.7406 10.8928 5.13333C10.8928 5.72244 11.3903 6.2 12.0039 6.2ZM16.4483 6.2C17.062 6.2 17.5595 5.72244 17.5595 5.13333C17.5595 4.7406 17.1891 4.02949 16.4483 3C15.7076 4.02949 15.3372 4.7406 15.3372 5.13333C15.3372 5.72244 15.8347 6.2 16.4483 6.2ZM4.13724 19H19.8706C21.0488 19 22.0039 18.0449 22.0039 16.8667H2.00391C2.00391 18.0449 2.95903 19 4.13724 19Z"
        stroke="#3A393A"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BirthDayIcon;
